import type { OnboardingStep } from "../context/OnboardingContext";

/**
 * The onboarding steps that can be edited inline from the review screen.
 * Everything except `source` (the entry choice) and `review` (the recap itself).
 */
export const EDITABLE_ONBOARDING_STEPS = [
  "sector",
  "skills",
  "job_title",
  "experience",
  "education",
  "locale",
  "summary",
  "pricing",
  "info",
  "online-presence",
] as const satisfies readonly OnboardingStep[];

export type EditableOnboardingStep = (typeof EDITABLE_ONBOARDING_STEPS)[number];

/**
 * Validate a raw `?edit=<step>` query value against the editable step set.
 * Returns the matching step, or `null` for unknown/non-editable/missing values.
 */
export const parseEditStep = (
  value: unknown,
): EditableOnboardingStep | null => {
  return (EDITABLE_ONBOARDING_STEPS as readonly string[]).includes(
    value as string,
  )
    ? (value as EditableOnboardingStep)
    : null;
};
